import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { grey, red } from '@material-ui/core/colors';
import { motion } from 'framer-motion';
//models
import Message from '../models/Message';
import { TextLinkResponse } from '../models/Conversation';
import { errorMessage } from '../models/Constants';

const useStyles = makeStyles((theme) => ({
    adi: {
      padding: theme.spacing(2),
      maxWidth: '300px',
      color: theme.palette.getContrastText(grey[200]),
      backgroundColor: grey[200],
      borderRadius:20,
      borderTopRightRadius: 10,
      borderBottomLeftRadius: 0,
    },
    error: {
      padding: theme.spacing(2),
      maxWidth: '300px',
      color: theme.palette.getContrastText(red[500]),
      backgroundColor: red[500],
      borderRadius:20,
      borderTopRightRadius: 5,
      borderBottomLeftRadius: 0,
    },
  }));

const MessageTextLink = (props:any) => {
    const classes = useStyles();
    const message:Message = props.message;
    if (!message.messageData) {
      message.messageData = errorMessage[Math.floor(Math.random() * errorMessage.length)];
      return (
        <motion.div
          animate={{
            x:[0,5,0],
            rotate:[0,-2,0,2,0]
          }}
          transition={{duration: 0.3}}
        >
        <Paper elevation={0} className={classes.adi}>
            {message.messageData}
        </Paper>
        </motion.div>
      );
    }
    else {
      const textLink:TextLinkResponse = message.messageData as TextLinkResponse;
      return (
        <Paper elevation={0} className={classes.adi}>
            <div dangerouslySetInnerHTML={{__html: textLink.text}} />
        </Paper>
      );
    }
   
};

export default MessageTextLink;